import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";
import {Cloneable} from "@/common/Cloneable";
import {ItemTouchAction} from "@/modules/redactor/models/item/touch/ItemTouchAction";

export class ItemTouchConfig extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(ItemTouchConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(ItemTouchConfig, v);
            }
        );
    }

    constructor() {
        super();

        this._longTouchAction = ItemTouchAction.DISABLED;
        this._longTouchReminder = false;
    }

    get longTouchAction() {
        return this._longTouchAction;
    }

    set longTouchAction(value) {
        this._longTouchAction = value;
    }

    get longTouchReminder() {
        return this._longTouchReminder;
    }

    set longTouchReminder(value) {
        this._longTouchReminder = value;
    }

    valid() {

        if (!ItemTouchAction.is(this.longTouchAction)) {
            return false;
        }

        return true;
    }

    empty() {
        return ItemTouchAction.DISABLED.equal(this.longTouchAction);
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemTouchConfig());
        } else if (target instanceof ItemTouchConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemTouchConfig, {
    _longTouchAction: alias("long_touch_action", ItemTouchAction.schema()),
    _longTouchReminder: alias("long_touch_reminder", Schema.primitive())
});